import {
    useEffect,
    useState,
} from "preact/compat";

import type {
    ReviewItem,
    ReviewOverrideBody,
} from "@mrflark/spl_sdk";
import {
    getPrimaryAnalysis,
} from "@mrflark/spl_sdk";

import {
    Button,
    Modal,
} from "@mrflark/ui";

type ReviewOverrideModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSave: (overrides: ReviewOverrideBody) => void;
    item: ReviewItem | null;
    isSaving: boolean;
};

export const ReviewOverrideModal = ({
    isOpen,
    onClose,
    onSave,
    item,
    isSaving,
}: ReviewOverrideModalProps) => {
    const [description, setDescription] = useState("");
    const [suggestedTags, setSuggestedTags] = useState("");

    useEffect(() => {
        if (item) {
            const primary = getPrimaryAnalysis(item.ai_analyses);
            setDescription(primary?.entry.description ?? "");
            setSuggestedTags("");
        }
    }, [item]);

    const handleSave = (): void => {
        const overrides: ReviewOverrideBody = {};

        if (description) overrides.description = description;
        if (suggestedTags) {
            overrides.suggested_tags = suggestedTags
                .split(",")
                .map((tag) => tag.trim())
                .filter(Boolean);
        }

        onSave(overrides);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="lg"
        >
            <div className="space-y-4">
                <h2 className="text-lg font-semibold">Edit & Approve</h2>
                <p className="text-sm text-text-secondary">
                    Edit the AI-generated fields before approving this item.
                </p>

                <div className="space-y-3">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">
                            Description
                        </label>
                        <textarea
                            value={description}
                            onChange={(event) =>
                                setDescription(
                                    (event.target as HTMLInputElement).value,
                                )}
                            className="input w-full h-24 resize-y"
                            placeholder="AI-generated description..."
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">
                            Suggested Tags (comma-separated)
                        </label>
                        <input
                            type="text"
                            value={suggestedTags}
                            onChange={(event) =>
                                setSuggestedTags(
                                    (event.target as HTMLInputElement).value,
                                )}
                            className="input w-full"
                            placeholder="tag1, tag2, tag3"
                        />
                    </div>
                </div>

                <div className="flex justify-end gap-2 pt-2">
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSave}
                        disabled={isSaving}
                    >
                        {isSaving ? "Saving..." : "Save & Approve"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
